export const PhoneNumberFormatter = () => {
  const ukrainianPhoneNumbersFormatter = {
    format(value) {
      if (!value) return '';

      let digits = value.replace(/\D/g, '');

      if (digits.length > 0 && !digits.startsWith('38')) {
        digits = '38' + digits;
      }

      digits = digits.slice(0, 12);

      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 5) return `+${digits.slice(0,2)} (${digits.slice(2)}`;
      if (digits.length <= 8) return `+${digits.slice(0,2)} (${digits.slice(2,5)}) ${digits.slice(5)}`;
      if (digits.length <= 10) return `+${digits.slice(0,2)} (${digits.slice(2,5)}) ${digits.slice(5,8)} ${digits.slice(8)}`;

      return `+${digits.slice(0,2)} (${digits.slice(2,5)}) ${digits.slice(5,8)} ${digits.slice(8,10)} ${digits.slice(10,12)}`;
    },

    revert(value) {
      if (!value) return '';

      let digits = value.replace(/\D/g, '');

      if (digits.length > 0 && !digits.startsWith('38')) {
        digits = '38' + digits;
      }

      return digits;
    }
  };

  return {
    ukrainianPhoneNumbersFormatter,
  };
};